import { GraphQLUserDataOutput } from '../models/output/graphql-user-data-output';
import { UserData } from 'src/app/models/user-data';

/**
 * Maps user data as received from the authentication source to internal model.
 * @param input GraphQL output of user data.
 * @returns Internal model.
 */
export function convertGraphqlUserDataOutputToUserData(input: GraphQLUserDataOutput): UserData {
	return {
		userName: input.Username,
		sessionUID: input.SessionUID,
		companyName: input.Company,
    isLoggedIn: input.IsAuthenticated,
    functionalGroups: input.FunctionalGroups,
    firstName: input.FirstName,
    lastName: input.LastName,
		// email: input.Email,
	};
}
